if (!window.Eurus.loadedScript.has('pagination.js')) {
  window.Eurus.loadedScript.add('pagination.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xPagination', (sectionId) => ({
        loading: false,
        error: false,
        lastLoadedUrl: '',
        async loadData(url) {
          if (this.loading) return;

          const requestUrl = new URL(url, window.location.href);
          requestUrl.searchParams.set('section_id', sectionId);
          requestUrl.hash = '';
          if (this.lastLoadedUrl === requestUrl.href) return;

          const section = document.getElementById('shopify-section-' + sectionId);
          const productsOnPage = section?.querySelector('#blog-grid') || section?.querySelector('#items-grid');
          const pagination = document.getElementById('btn-pagination-' + sectionId);
          if (!productsOnPage || !pagination) return;

          this.loading = true;
          this.error = false;

          try {
            // Fetch only this section, rather than another complete storefront page.
            const response = await fetch(requestUrl.href);
            if (!response.ok) throw new Error('Pagination request failed: ' + response.status);

            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const productGrid = html.getElementById(productsOnPage.id) || html.getElementById('items-grid');
            if (!productGrid) throw new Error('Pagination response is missing the product grid');

            // A filter/sort change may have replaced the grid while the request was in flight.
            if (!productsOnPage.isConnected || !pagination.isConnected) return;

            const newProducts = Array.from(productGrid.getElementsByClassName('grid-item'));
            // One DOM update avoids retaining an entire response in a timer for every card.
            productsOnPage.insertAdjacentHTML('beforeend', newProducts.map(item => item.innerHTML).join(''));
            this.lastLoadedUrl = requestUrl.href;

            // Release the loading state before the new infinite-scroll trigger is observed.
            this.loading = false;
            const nextPagination = html.getElementById('btn-pagination-' + sectionId);
            pagination.innerHTML = nextPagination ? nextPagination.innerHTML : '';
          } catch (error) {
            this.error = true;
            console.error(error);
          } finally {
            this.loading = false;
          }
        }
      }));
    });
  });
}
